/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, Grid, Typography } from "@mui/material";
import React, { Fragment } from "react";

import MHButton from "../../Common/Button/MHButton";

import { ReactComponent as DownloadIcon } from "../../../static/svg/downloads.svg";
import { ReactComponent as Instagram } from "../../../static/svg/instagram.svg";
import { ReactComponent as Facebook } from "../../../static/svg/facebook.svg";
import { ReactComponent as Pinterest } from "../../../static/svg/pinterest.svg";
import { ReactComponent as Twitter } from "../../../static/svg/twitter.svg";

import { ReactComponent as YoutubeIcon } from "../../../static/svg/youtube.svg";
import { ReactComponent as SpotifyIcon } from "../../../static/svg/spotify.svg";

import { ItemList } from "../../../models/resources.interface";

type HeaderProps = {
  titles?: string;
  description?: string;
  imageUrl?: string;
  headerClassName?: string;
  headerDateClass?: string;
  downloadClassName?: string;
  imageClass?: string;
  ticketClassName?: string;
  writtenBy?: string;
  bottomDateClass?: string;
  authorClassName?: string;
  SocialClassName?: string;
  TabSocialClass?: string;
  categoryClassName?: string;
  spotifyUrl?: string;
  youtubeUrl?: string;
  downloadLink?: string;
  ticketLink?: string;
  categoryOne?: string;
  category?: ItemList[] | undefined;
  date?: string | undefined;
  startTime?: string | undefined;
  endTime?: string | undefined;
  dateTwo?: string | undefined;
  onClick?: string;
  dateClassName?: string;
  podClassName?: string;
  episode?: string;
  episodeLength?: string;
  season?: string;
  episodeClassName?: string;
  event?: boolean;
};

const ViewHeader = (props: HeaderProps) => {
  const formattedLength = React.useMemo(() => {
    if (!props.episodeLength) return "";

    const value = Number(props.episodeLength);

    const mins = Math.floor(value);
    const secs = Math.round((value - mins) * 100);

    if (mins < 60) {
      return secs > 0 ? `${mins} mins ${secs} secs` : `${mins} mins`;
    }

    const hrs = Math.floor(mins / 60);
    const remainingMins = mins % 60;

    return secs > 0
      ? `${hrs} hr ${remainingMins} mins ${secs} secs`
      : `${hrs} hr ${remainingMins} mins`;
  }, [props.episodeLength]);

  return (
    <Fragment>
      <Grid container spacing={0} className="relative overflown-hidden">
        <Grid item xs={12} sm={6.5} md={6.5} lg={6.5}>
          <Box className={props.headerClassName}>
            <Typography
              variant="body2"
              className={props.headerDateClass}
              color="primary"
            >
              {props.dateTwo}
            </Typography>
            <Typography
              variant="body2"
              color="primary"
              className="text-left my-6 w-4/4 font-columbia text-3xl capitalize font-[500]"
            >
              <Typography
                variant="body2"
                className={props.dateClassName}
                color="primary"
              >
                {props.date}
              </Typography>
              <Typography
                variant="body2"
                className={props.episodeClassName}
                color="primary"
              >
                Episode {props.episode}
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                className="md:text-left lg:leading-[120.5%] text-center h-fit md:w-[98%] lg:w-[98%] lg:line-clamp-4 md:line-clamp-4 line-clamp-6 font-columbia text-2xl md:text-xl lg:text-[32px] capitalize font-[500]"
                // h-28 md:h-24 lg:h-36
              >
                {props.titles}
              </Typography>
            </Typography>
            <Typography
              variant="body2"
              className="md:text-left pt-6 md:pt-0 lg:pt-2  text-center lg:w-[493px] md:w-[85%] text-[14px] line-clamp-6 md:line-clamp-3 font-areaSemi"
              color="primary"
            >
              {props.description}
            </Typography>

            {/* {props.event && (
              <Box className="block md:hidden text-center py-5">
                <Typography
                  gutterBottom
                  variant="h5"
                  component="p"
                  fontSize={{ xs: "20px", sm: "14px", md: "20px" }}
                >
                  {props.startTime} - {props.endTime} EST
                </Typography>
              </Box>
            )} */}
            {/* <Box className="flex -ml-4 my-2"> */}
            <Box className={props.downloadClassName}>
              <a
                download
                onClick={() => {
                  window.open(props.downloadLink);
                }}
                title="Click to download"
              >
                <DownloadIcon className="h-12 mt-8" />
              </a>

              <a
                download
                onClick={() => {
                  window.open(props.downloadLink);
                }}
                title="Click to download"
                className="no-underline"
              >
                <Typography
                  variant="body2"
                  className="text-left mt-12 text-xs uppercase font-areaBold tracking-wider"
                  color="primary"
                >
                  Download Toolkit
                </Typography>
              </a>
            </Box>
            <Box className={props.ticketClassName}>
              <MHButton
                onClick={() => {
                  window.open(props.ticketLink);
                }}
                sx={{ width: "155px" }}
              >
                Reserve A Seat
              </MHButton>
            </Box>

            <Box className={props.podClassName}>
              <Box>
                <MHButton
                  onClick={() => window.open(props.spotifyUrl, "_blank")}
                  sx={{
                    color: "primary.main",
                    backgroundColor: "#fff",
                    borderRadius: "36px",
                    "&:hover": {
                      backgroundColor: "#fff",
                      color: "primary.main",
                    },
                  }}
                  startIcon={<SpotifyIcon />}
                  className="w-full md:w-[250px] h-10 md:h-[45px] font-areaExt text-[10px] md:text-xs"
                >
                  Listen on Spotify
                </MHButton>
              </Box>

              <Box>
                <MHButton
                  onClick={() => window.open(props.youtubeUrl, "_blank")}
                  sx={{
                    color: "primary.main",
                    backgroundColor: "#fff",
                    borderRadius: "36px",
                    "&:hover": {
                      backgroundColor: "#fff",
                      color: "primary.main",
                    },
                  }}
                  startIcon={<YoutubeIcon />}
                  className="w-full md:w-[250px] h-10 md:h-[45px] font-areaExt text-[10px] md:text-xs"
                >
                  Watch on YouTube
                </MHButton>
              </Box>
            </Box>

            {props.episodeLength && (
              <Box className=" lg:-bottom-4 lg:absolute md:relative mb:py-2 mb-14 md:w-2/3 text-start">
                <Typography
                  gutterBottom
                  variant="body1"
                  // component="p"
                  fontSize={{ xs: "20px", sm: "14px", md: "20px" }}
                  className=" italic text-center md:text-start"
                >
                  {formattedLength}
                </Typography>
              </Box>
            )}

            <Box className={props.authorClassName} color="primary">
              BY {props.writtenBy}
            </Box>

            <Box className={props.categoryClassName}>
              <Box className="lg:py-9 md:py-2 py-12">
                <Typography
                  className="text-[15px] text-center md:text-left font-areaExt uppercase text-navy-900"
                  gutterBottom
                  variant="h5"
                >
                  {props.categoryOne}
                </Typography>
                <Typography
                  variant="body2"
                  className="text-center md:text-left py-2 md:py-0 lg:py-2 text-[12px] opacity-50 capitalize font-areaSemi"
                  color="primary"
                >
                  {props.categoryOne ? (
                    <div
                      className="text-[14px] capitalize truncate text-navy-900 font-areaSemi"
                      // size="small"
                      // disabled
                    >
                      {props
                        .category!.map((item) => item.interestName)
                        .join(", ")}
                    </div>
                  ) : null}
                </Typography>
              </Box>

              <Box className={props.bottomDateClass}>
                <Typography
                  variant="body2"
                  className="lg:absolute text-left my-2 hidden md:block text-[12px] uppercase font-areaExt"
                  color="primary"
                >
                  {props.dateTwo}
                </Typography>
              </Box>

              {/* {props.event && (
                <Box className="hidden md:block">
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="p"
                    fontSize={{ xs: "20px", sm: "16px", md: "22px" }}
                  >
                    {props.startTime} - {props.endTime} EST
                  </Typography>
                </Box>
              )} */}
            </Box>

            <Box className={props.SocialClassName}>
              {/* Web */}
              <Box className="absolute gap-4 bottom-6 md:bottom-14  text-center place-content-center hidden md:hidden lg:flex md:right-10 lg:right-20">
                <a
                  className="cursor-pointer"
                  href="https://instagram.com/mhworklife?igshid=YmMyMTA2M2Y="
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Instagram />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://www.facebook.com/motherhonestly?mibextid=LQQJ4d"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Facebook />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://www.pinterest.com/motherhonestly/"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Pinterest />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://twitter.com/mhworklife?s=21&t=lhmzHgRp7adyrrMjPPyrsw"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Twitter />
                </a>
              </Box>
              {/* Tab */}
              <Box className={props.TabSocialClass}>
                <a
                  className="cursor-pointer"
                  href="https://instagram.com/mhworklife?igshid=YmMyMTA2M2Y="
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Instagram />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://www.facebook.com/motherhonestly?mibextid=LQQJ4d"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Facebook />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://www.pinterest.com/motherhonestly/"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Pinterest />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://twitter.com/mhworklife?s=21&t=lhmzHgRp7adyrrMjPPyrsw"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Twitter />
                </a>
              </Box>
              {/* Mobile */}
              <Box className="absolute gap-4 bottom-6 md:bottom-9  text-center place-content-center flex md:hidden right-0 left-0">
                <a
                  className="cursor-pointer"
                  href="https://instagram.com/mhworklife?igshid=YmMyMTA2M2Y="
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Instagram />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://www.facebook.com/motherhonestly?mibextid=LQQJ4d"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Facebook />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://www.pinterest.com/motherhonestly/"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Pinterest />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://twitter.com/mhworklife?s=21&t=lhmzHgRp7adyrrMjPPyrsw"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Twitter />
                </a>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={5.5} md={5.5} lg={5.5} className="relative">
          <Box className="bg-green-100 h-96 w-full viewImage md:h-full lg:h-[500px] lg:w-full object-cover">
            <img
              src={props.imageUrl}
              alt="Resources Image"
              className={props.imageClass}
              draggable={false}
            />
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default ViewHeader;
